<template>
  <div>
    <h1 class="text-center">CPB Product full description to CRM Triggers</h1>
    <v-progress-circular
      v-if="isLoading"
      :size="70"
      :width="7"
      color="primary"
      indeterminate
      class="centered"
    ></v-progress-circular>
    <div v-else>
      <div class="pt-5">
        <div class="d-flex justify-content-start">
          <input
            type="file"
            class="form-control w-50"
            ref="importedCPBProductDesFile"
            @change="changeCPBProductFile"
            :class="{
              'input--error': isSubmit && error.errorPath,
            }"
            :disabled="isFileLoading"
          />
          <FileLoading extra-class="ml-5 pt-1" v-if="isFileLoading" />
          <button v-else class="btn btn-outline-primary ml-5" @click="onSubmit">
            Save
          </button>
        </div>
        <div v-if="isSubmit && error.errorPath" class="text-error">
          {{ error.errorPath.message }}
        </div>
        <div class="pt-5">
          <a
            href="#"
            target="_blank"
            @click.prevent="downloadCPBSampleFile"
            class="download-sample-file-link"
            >Download sample file</a
          >
          <a
            v-if="currentFile"
            href="#"
            target="_blank"
            class="pl-5"
            @click.prevent="downloadCurrentCPBProductDescFile"
            >Download current file</a
          >
        </div>
      </div>

      <div class="mt-3" v-if="listProductDescription.length > 0">
        <div class="row">
          <div class="d-flex align-items-center justify-content-start col">
            <span class="mr-2">Show</span>
            <b-form-select
              class="form-control w-auto"
              v-model="perPage"
              :options="pageOptions"
              @change="onChangeEntries"
            ></b-form-select>
            <span class="ml-2">entries</span>
          </div>
          <div class="d-flex align-items-center justify-content-end col">
            <label class="mx-3" for="cpbProductSearch">Search: </label>
            <input
              id="cpbProductSearch"
              type="text"
              v-model="searchText"
              class="form-control w-50"
              @change="getList"
            />
          </div>
        </div>
        <b-table
          class="table table-responsive table-bordered mt-5"
          hover
          responsive
          :fields="fields"
          :items="listProductDescription"
          :per-page="perPage"
          @sort-changed="sortCompare"
        >
        </b-table>
        <b-pagination
          :total-rows="totalItems"
          v-model="currentPage"
          :per-page="perPage"
          class="my-0"
          aria-controls="my-table"
          @input="changePage"
        ></b-pagination>
      </div>
      <v-dialog v-model="showDialog" width="500" persistent>
        <div class="content-dialog">
          <h5 class="p-5 text-center">{{ message }}</h5>
          <div class="text-center">
            <button class="btn-back" @click="showDialog = false">ปิด</button>
          </div>
        </div>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import PresignedUploadUrlService from "services/api/presignedUploadUrl.service";
import CPBProductFullDescriptionService from "services/api/cpbProductFullDescription.service";
import DefaultListViewData from "@/views/defaultListViewData";
import FileLoading from "components/Loading/FileLoading.vue";
import fields from "./listCPBProductFullDescriptionFields.json";

export default {
  components: { FileLoading },
  data() {
    return {
      ...DefaultListViewData,
      path: null,
      processId: null,
      currentFile: null,
      listProductDescription: [],
      isFileLoading: false,
      message: null,
      showDialog: false,
      isSubmit: false,
      fields,
      error: {
        errorPath: null,
      },
    };
  },
  mounted() {
    this.isLoading = true;
    this.getList(this.sort);
  },
  methods: {
    downloadCPBSampleFile() {
      try {
        window.open(
          process.env.VUE_APP_HOST_API +
            "static/sample/sampleCpbProductFullDesc.xlsx"
        );
      } catch (error) {
        console.log("Error: ", error);
      }
    },
    downloadCurrentCPBProductDescFile() {
      try {
        window.open(this.currentFile);
      } catch (error) {
        console.log("Error: ", error);
      }
    },
    changeCPBProductFile() {
      const importFile = this.$refs.importedCPBProductDesFile.files[0];
      this.getPresignURL(importFile);
    },
    async getPresignURL(file) {
      this.isFileLoading = true;
      await PresignedUploadUrlService.getS3SignUrl(
        "cpbProductFullDescription",
        file
      )
        .then((res) => {
          const data = res.data;
          this.path = data.key;
          this.updatePhotoToS3(data.presignedUrl, file);
        })
        .catch((err) => {
          console.log("Error: ", err.response);
        });
    },
    async updatePhotoToS3(url, file) {
      await PresignedUploadUrlService.pushProfilePhotoToS3(url, file);
      this.isFileLoading = false;
    },
    async onSubmit() {
      this.isLoading = true;
      this.isSubmit = true;
      this.resetErrorText();
      const body = {
        path: this.path,
      };
      this.resetFile();
      await this.uploadFile(body);
    },
    async uploadFile(body) {
      await CPBProductFullDescriptionService.uploadCPBProductFullDescription(
        body
      )
        .then((res) => {
          const data = res.data;
          this.processId = data.processId;
          this.getListInterval = setInterval(() => {
            this.getResult();
          }, 10000);
        })
        .catch((err) => {
          this.isLoading = false;
          console.log("Error: ", err);
          const errorData = err.response?.data;
          if (errorData.errors?.length > 0) {
            this.setErrorText(errorData.errors);
            return;
          }
          if (errorData.message) {
            this.showDialog = true;
            this.message = errorData.message;
          }
        });
    },
    clearTimeInterval() {
      clearInterval(this.getListInterval);
    },
    async getResult() {
      const param = {
        process: this.processId,
      };
      await CPBProductFullDescriptionService.getCPBProductFullDescriptionResult(
        param
      )
        .then(async (res) => {
          const data = res.data;
          if (data.processStatus.toUpperCase() === "EXECUTED") {
            this.clearTimeInterval();
            await this.getList(this.sort);
            this.message = data.message;
            if (data.status === "success") {
              this.message = data.message || "Successfully imported file";
            }
            this.showDialog = true;
          }
        })
        .catch((err) => {
          console.log("Error: ", err);
          const errRes = err.response;
          if (errRes.status !== 400) {
            this.isLoading = false;
            this.clearTimeInterval();
            this.message =
              errRes.data?.message ||
              "An error occurred, please try again later!";
            this.showDialog = true;
          }
        });
    },
    async getList(sort) {
      const param = {
        keyword: this.searchText,
        currentPage: this.currentPage,
        limit: this.perPage,
        sortColumn: sort.key || "id",
        sortType: sort.type || "desc",
      };
      await CPBProductFullDescriptionService.getListCPBProductFullDescription(
        param
      )
        .then((res) => {
          const data = res.data;
          this.totalItems = data.totalItems;
          this.listProductDescription = data.cpbProductDisplayNames;
          this.currentFile = data.importFileUrl;
          this.isLoading = false;
        })
        .catch((err) => {
          console.log("Error: ", err);
          this.isLoading = false;
        });
    },
    changePage() {
      this.getList(this.sort);
    },
    onChangeEntries() {
      this.getList(this.sort);
    },
    sortCompare(e) {
      let sortBy = e.sortBy;
      this.sort = {
        key: sortBy,
        type: e.sortDesc ? "desc" : "asc",
      };
      this.getList(this.sort);
    },
    setErrorText(errors) {
      this.error.errorPath = errors.find((e) => e.fieldName === "path");
    },
    resetErrorText() {
      this.error.errorPath = null;
    },
    resetFile() {
      this.path = null;
      this.$refs.importedCPBProductDesFile.value = null;
    },
  },
};
</script>

<style lang="scss" scoped>
.centered {
  position: absolute;
  top: 45%;
  left: 50%;
}

.download-sample-file-link {
  color: #6e6e6e;
}
</style>
